import { Navigate, Route, Routes } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { GeneratorPage } from "@/features/generator";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { VerifyEmailPage } from "@/features/verify-email";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<GeneratorPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
